<template>
  <div class="manage">
    <div class="tips">
      <p>1:您可以将好友添加为副店长。</p>
      <p>2:副店长可以使用提醒用户取货、扫码提货等功能，协助您进行发货。</p>
      <p>3:副店长不会看到您的利润</p>
    </div>
    <van-swipe-cell
      v-for="(item,index) in list"
      :key="index"
      :before-close="beforeClose"
      :name="index"
    >
      <div class="common">
        <div class="common-img">
          <img
            :src="imgPrex + item.headpic"
            alt
          />
        </div>
        <div class="common-title">
          <div class="common-name van-ellipsis">{{item.name}}</div>
          <div class="common-phone">手机号:{{item.mobile}}</div>
        </div>
        <div class="common-callPhone">
          <i
            class="iconfont icon-oider_icon_call"
            @click="dialPhone(item.mobile)"
          ></i>
        </div>
      </div>
      <template #right>
        <div class="right-botton">
          <div class="fillet"></div>
          <van-button
            square
            text="移除"
            type="danger"
            class="delete-button"
          />
        </div>
      </template>
    </van-swipe-cell>
    <van-button
      class="btn"
      text="添加副店长"
      block
      @click="addAssistant"
    />
    <!-- 添加副店长 -->
    <van-dialog
      id="add"
      v-model="showDialog"
      title="添加副店长"
      confirm-button-text="确认添加"
      confirm-button-color="#50BE4C"
      cancel-button-color="#1D1D1D"
      show-cancel-button
      :before-close="addShopowner"
    >
      <van-form
        ref="submits"
        name="submits"
        validate-first
        :show-error="false"
      >
        <van-field
          name="mobile"
          v-model.trim="form.mobile"
          type="digit"
          placeholder="请输入您要添加的副店长手机号"
          maxlength="11"
          :rules="[{ required: true, message: '请输入您要添加的副店长手机号' }]"
        />
        <van-field
          name="vcode"
          v-model.trim="form.vcode"
          center
          placeholder="请输入验证码"
          maxlength="6"
          :rules="[{ required: true, message: '请输入验证码' }]"
        >
          <template #button>
            <van-button
              native-type="button"
              type="default"
              :text="verifyCode"
              class="code-btn"
              :disabled="disabled"
              @click="getSend"
            />
          </template>
        </van-field>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { getVCode, storeAssistantList, removeStoreAssistant, addStoreAssistant } from "@/api/join";
export default {
  data() {
    return {
      list: [],
      showDialog: false,
      form: {
        mobile: "",
        vcode: "",
      },
      verifyCode: "获取验证码",
      disabled: false,
      timer: null
    }
  },
  methods: {
    addAssistant() {
      if (this.list.length < 10) {
        this.showDialog = true;
      } else {
        this.$toast("最多添加10个副店长");
      }
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    beforeClose({ name, position, instance }) {
      switch (position) {
        case 'right':
          this.$dialog.alert({
            message: "您确定要移除副店长吗？",
            confirmButtonText: "确定",
            confirmButtonColor: "#50BE4C",
            cancelButtonText: "取消",
            cancelButtonColor: "#1D1D1D",
            showCancelButton: true,
          })
            .then(() => {
              removeStoreAssistant({
                memberId: this.list[name].memberId,
              }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                  this.$toast("移除成功");
                  this.list.splice(name, 1);
                  instance.close();
                }
              })
            })
            .catch(() => {
              instance.close();
            })
          break;
      }
    },
    async addShopowner(action, done) {
      if (action === "confirm") {
        let mobileError = false, vcodeError = false;
        await this.$refs.submits.validate("mobile").catch(() => {
          mobileError = true;
        });
        await this.$refs.submits.validate("vcode").catch(() => {
          vcodeError = true;
        });
        if (!mobileError && !vcodeError) {
          addStoreAssistant({
            mobile: this.form.mobile,
            vcode: this.form.vcode,
          }).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.getAssistantList();
              done();
              this.$toast("添加成功");
              this.resetData();
            } else {
              done(false);
            }
          })
        } else {
          done(false);
        }
      } else {
        done();
        this.resetData();
      }
    },
    // 重置数据
    resetData() {
      clearTimeout(this.timer);
      this.disabled = false;
      this.verifyCode = "获取验证码";
      this.$refs.submits.resetValidation("mobile"); //重置表单错误提示
      this.$refs.submits.resetValidation("vcode");  //重置表单错误提示
      Object.assign(this.$data.form, this.$options.data().form);
    },
    sendCode(i) {
      //获取验证码
      i = i - 1;
      this.verifyCode = i + "s后重新获取";
      this.disabled = true;
      if (i == 0) {
        this.verifyCode = "重新发送";
        this.disabled = false;
        return;
      }
      this.timer = setTimeout(() => {
        this.sendCode(i);
      }, 1000);
    },
    async getSend() {
      let mobileError = false;
      await this.$refs.submits.validate("mobile").catch(() => {
        mobileError = true;
      });
      if (!mobileError) {
        getVCode({
          phone: this.form.mobile,
          type: "2"
        }).then((res) => {
          if (res.appStatus.errorCode == 0) {
            this.sendCode(60);
          }
        });
      }
    },
    getAssistantList() {
      storeAssistantList({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.list = res.content.list;
        }
      });
    },
  },
  mounted() {
    this.getAssistantList();
  }
}
</script>

<style lang="scss" scoped>
.manage {
  padding-bottom: 64px;
}
.tips {
  width: 345px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 15px;
  font-size: 12px;
  color: #3e3e3e;
  background-color: #ffe9d5;
  p:not(:first-child) {
    margin-top: 2px;
  }
}
.common {
  display: flex;
  align-items: center;
  width: 100%;
  height: 70px;
  padding: 10px 15px;
  box-sizing: border-box;
  border-radius: 0px 10px 10px 0px;
  overflow: hidden;
  .common-img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
  .common-title {
    flex: 1;
    overflow: hidden;
    .common-name {
      max-width: 210px;
      font-size: 20px;
      font-weight: 800;
    }
    .common-phone {
      font-size: 12px;
      color: #8d8d8d;
      margin-top: 5px;
    }
  }
  .common-callPhone {
    width: 31px;
    height: 31px;
    i {
      font-size: 22px;
      color: #50be4c;
    }
  }
}
.right-botton {
  width: 50px;
  height: 100%;
  display: flex;
  position: relative;
  .fillet {
    width: 10px;
    height: 100%;
    position: absolute;
    left: 0;
    z-index: 2;
    border-radius: 0px 10px 10px 0px;
    background-color: #ffffff;
    overflow: hidden;
  }
}
.delete-button {
  width: 50px;
  height: 100%;
  line-height: 1.8;
  padding-left: 25px;
  font-size: 16px;
  background: linear-gradient(91deg, #fb6a4a 0%, #ff0808 54%, #ff0808 100%);
  border: none;
}
.btn {
  width: 355px;
  height: 44px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  background-color: #50be4c;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  border-width: 0;
  border-radius: 25px;
}
.code-btn {
  width: 90px;
  height: 40px;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #50be4c;
  border-radius: 5px;
  &.van-button--disabled {
    font-size: 12px;
    color: #999999;
    background: #ffffff !important;
    opacity: 1;
    border: 1px solid #b4b4b4 !important;
  }
}
</style>
<style scoped>
#add >>> .van-dialog__header {
  padding: 10px 0;
  font-size: 17px;
  font-weight: 800;
  color: #1d1d1d;
}
#add >>> .van-cell {
  width: auto;
  margin: 0 10px;
  padding: 0;
}
#add >>> .van-field__control {
  height: 40px;
  padding: 7px 5px;
  border: 1px solid #b4b4b4;
  border-radius: 5px;
}
#add >>> .van-cell__value {
  min-height: 62px;
}
#add >>> .van-field__error-message {
  margin-top: 2px;
  line-height: normal;
  font-size: 11px;
  color: #fd3325;
}
</style>